export class User {

  public password: string;
  public passwordRepeat: string;

  constructor(
    public hash?: string,
    public firstName?: string,
    public lastName?: string,
    public email?: string,
    public role?: number
  ) { }

  clone() {
    return new User(
      this.hash,
      this.firstName,
      this.lastName,
      this.email,
      this.role
    );
  }

  get fullName() {
    return `${ this.firstName } ${ this.lastName }`;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/user.ts